import { EPaletteModes } from '@/types/theme-packs.types';
import { CSSProperties } from 'react';

export enum EPreviewSize {
  MOBILE = 'mobile',
  TABLET = 'tablet',
  DESKTOP = 'desktop',
  FULL = 'full',
}

export enum EPanelDirections {
  LTR = 'ltr',
  RTL = 'rtl',
}

export type GridItemState = boolean | 'store-value';

export type LayoutGridState = {
  direction: EPanelDirections;
  panelOpen: GridItemState;
  oppositePanelOpen: GridItemState;
  footerOpen: GridItemState;
  pillarOpen: GridItemState;
  headerOpen: GridItemState;
  previewSize: EPreviewSize;
  gridLayoutLTR: CSSProperties['gridTemplateAreas'];
  gridLayoutRTL: CSSProperties['gridTemplateAreas'];
  preFullScreenState: {
    direction: EPanelDirections;
    panelOpen: GridItemState;
    oppositePanelOpen: GridItemState;
    footerOpen: GridItemState;
    pillarOpen: GridItemState;
    headerOpen: GridItemState;
    previewSize: EPreviewSize;
  } | null;
  bodyAttributes: TLayoutBodyAttributes;
};

export type TLayoutBodyAttributes = {
  theme: EPaletteModes;
};

export type SetLayoutGridState = Pick<
  LayoutGridState,
  'direction' | 'panelOpen' | 'oppositePanelOpen' | 'footerOpen' | 'pillarOpen' | 'headerOpen'
>;

export enum EGridAreas {
  Header = 'header',
  Pillar = 'pillar',
  Panel = 'panel',
  Main = 'main',
  OppositePanel = 'oppositePanel',
  Footer = 'footer',
}

export const defaultLayoutGrids: Record<EPanelDirections, CSSProperties['gridTemplateAreas']> = {
  [EPanelDirections.LTR]: `
    "${EGridAreas.Header} ${EGridAreas.Header} ${EGridAreas.Header} ${EGridAreas.Header}"
    "${EGridAreas.Pillar} ${EGridAreas.Panel} ${EGridAreas.Main} ${EGridAreas.OppositePanel}"
    "${EGridAreas.Footer} ${EGridAreas.Footer} ${EGridAreas.Footer} ${EGridAreas.Footer}"
  `,
  [EPanelDirections.RTL]: `
    "${EGridAreas.Header} ${EGridAreas.Header} ${EGridAreas.Header} ${EGridAreas.Header}"
    "${EGridAreas.OppositePanel} ${EGridAreas.Main} ${EGridAreas.Panel} ${EGridAreas.Pillar}"
    "${EGridAreas.Footer} ${EGridAreas.Footer} ${EGridAreas.Footer} ${EGridAreas.Footer}"
  `,
};
